import React, { createContext, useContext, useRef } from 'react';

const FormSaveContext = createContext();

export const useFormSave = () => {
    const context = useContext(FormSaveContext);
    if (!context) {
        throw new Error('useFormSave must be used within a FormSaveProvider');
    }
    return context;
};

export const FormSaveProvider = ({ children }) => {
    const saveHandlerRef = useRef(null);

    // Register a save handler from the current form
    const registerSaveHandler = (handler) => {
        saveHandlerRef.current = handler;
    };

    // Unregister when form unmounts
    const unregisterSaveHandler = () => {
        saveHandlerRef.current = null;
    };

    // Call the registered save handler (used by TokenExpiryCheck)
    const triggerSave = async () => {
        if (saveHandlerRef.current) {
            console.log('Auto-saving form before logout...');
            try {
                await saveHandlerRef.current();
                return true;
            } catch (error) {
                console.error('Error auto-saving form:', error);
                return false;
            }
        }
        return true; // No handler registered, nothing to save
    };

    return (
        <FormSaveContext.Provider value={{ registerSaveHandler, unregisterSaveHandler, triggerSave }}>
            {children}
        </FormSaveContext.Provider>
    );
};
